// src/pages/reports/HsnSummaryReport.js
import React, { useState } from "react";
import Layout from "../../components/Layout";
import { db } from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


function toStart(d){ const x=new Date(d);x.setHours(0,0,0,0);return Timestamp.fromDate(x);}
function toEnd(d){ const x=new Date(d);x.setHours(23,59,59,999);return Timestamp.fromDate(x);}
function dmy(ts){ return ts.toDate().toLocaleDateString("en-IN"); }

export default function HsnSummaryReport() {
  const today = new Date().toISOString().slice(0,10);
  const [fromDate,setFromDate]=useState(today);
  const [toDate,setToDate]=useState(today);
  const [party,setParty]=useState("");
  const [rows,setRows]=useState([]);

  const loadReport = async () => {
    const q = query(
      collection(db,"orderLines"),
      where("status","==","APPROVED"),
      where("approvedAt",">=",toStart(fromDate)),
      where("approvedAt","<=",toEnd(toDate))
    );





    const snap = await getDocs(q);
    const map = new Map();

    snap.forEach(d=>{
      const r=d.data();
      if(party && r.partyName!==party) return;

      const key = `${r.displayOrderId}__${r.hsn}`;
      if(!map.has(key)){
        map.set(key,{
          Date:dmy(r.approvedAt),
          Party:r.partyName,
          Vehicle:r.vehicleNo,
          Challan:r.displayOrderId,
          HSN:r.hsn,
          Qty:0,
          Basic:0,
          GST:0,
          Cess:0,
          Addl:0,
          Eway:0
        });
      }
	  
	  
	  
	  
	  
      const g=map.get(key);
      g.Qty+=r.qty||0;
      g.Basic+=r.basicAmount||0;
      g.GST+=r.gstAmount||0;
      g.Cess+=r.cessAmount||0;
      g.Addl+=r.addlCessAmount||0;
      g.Eway+=r.ewayLineTotal||0;
    });





    const sortedRows = Array.from(map.values()).sort((a, b) => {
  // 1️⃣ Sort by Challan (displayOrderId) ASC
  if (a.Challan < b.Challan) return -1;
  if (a.Challan > b.Challan) return 1;

  // 2️⃣ Inside same Challan → HSN ASC
  return String(a.HSN).localeCompare(String(b.HSN));
});

setRows(sortedRows);

  };


const exportExcel = () => {
  if (!rows.length) {
    alert("No data to export");
    return;
  }

  const excelRows = rows.map(r => ({
    Date: r.Date,
    Party: r.Party,
    Vehicle: r.Vehicle,
    Challan: r.Challan,
    HSN: r.HSN,
    Qty: r.Qty,
    BasicAmount: r.Basic,
    GSTAmount: r.GST,
    CessAmount: r.Cess,
    AddlCessAmount: r.Addl,
    EwayAmount: r.Eway,
  }));

  const ws = XLSX.utils.json_to_sheet(excelRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "HSN Summary");

  const buffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    `HSN_Summary_${fromDate}_to_${toDate}.xlsx`
  );
};



  return (
    <Layout>
      <div style={{padding:20}}>
        <h2>HSN Summary Report</h2>

        <input type="date" value={fromDate} onChange={e=>setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={e=>setToDate(e.target.value)} />
        <input placeholder="Party Name (optional)" onChange={e=>setParty(e.target.value)} />
        <button onClick={loadReport}>Load</button>
          
		  
		  

<button
  onClick={exportExcel}
  style={{ marginLeft: 10 }}
>
  Export Excel
</button>

		  
		  

        <table border="1" cellPadding="6">
          <thead>
            <tr>
              <th>Date</th><th>Party</th><th>Vehicle</th><th>Challan</th>
              <th>HSN</th><th>Qty</th><th>Basic</th><th>GST</th><th>Cess</th><th>Addl</th><th>Eway</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r,i)=>(
              <tr key={i}>
                <td>{r.Date}</td><td>{r.Party}</td><td>{r.Vehicle}</td><td>{r.Challan}</td>
                <td>{r.HSN}</td><td>{r.Qty}</td>
                <td>{r.Basic.toFixed(2)}</td><td>{r.GST.toFixed(2)}</td>
                <td>{r.Cess.toFixed(2)}</td><td>{r.Addl.toFixed(2)}</td>
                <td>{r.Eway.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
